import 'intl-tel-input'

export const getDialCodeForCountry = (countryCode) => {
  if (!countryCode) return null
  const getCountryData = window.intlTelInputGlobals?.getCountryData
  if (!getCountryData) return null
  const country = getCountryData().find(
    (c) => c.iso2 === countryCode.toLowerCase()
  )
  return country ? `+${country.dialCode}` : null
}

export const isDialCodeOnly = (value, countryCode) => {
  return value === '+' || value === getDialCodeForCountry(countryCode)
}

export const formatMaskedPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return ''

  const digits = phoneNumber.replace(/\D/g, '')
  if (digits.length < 4) return phoneNumber

  const lastThree = digits.slice(-3)
  const dialCode = phoneNumber.startsWith('+') ? `+${digits.slice(0, 1)}` : '+'

  return `${dialCode} ••• ••• •${lastThree}`
}
